// extracted by mini-css-extract-plugin
export default {"sampleItem":"AnimationSetting_sampleItem__27X1I","sampleItemText":"AnimationSetting_sampleItemText__k1vBH"};